import { FUNDINGUUPS_ADDRESS } from "../constants";
import { fundingUupsAbi } from "../fundingAbi";
import { getReadWeb3, getWriteWeb3, getAccountAddress } from "../index";

let fundingWriteContract;

export function getFundingReadContract(web3 = getReadWeb3()) {
  return new web3.eth.Contract(fundingUupsAbi, FUNDINGUUPS_ADDRESS);
}

export function getFundingWriteContract() {
  const web3 = getWriteWeb3();
  if (!web3) return null;
  if (!fundingWriteContract) {
    fundingWriteContract = new web3.eth.Contract(fundingUupsAbi, FUNDINGUUPS_ADDRESS, {
      from: getAccountAddress(),
      gasPrice: "0",
    });
  }
  return fundingWriteContract;
}

export function resetFundingWriteContract() {
  fundingWriteContract = null;
}
